import * as yup from "yup";

export const schema = yup.object().shape({
  first_name: yup.string().required("Required"),
  last_name: yup.string().required("Required"),
  shipping_line_1: yup.string(),
  shipping_line_2: yup.string(),
  shipping_city: yup.string(),
  shipping_state: yup.string(),
  shipping_postal_code: yup.string()
    .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Please enter a valid zip code. Must be 5 or 9 digits.')
    .label('ZIP Code'),
  shipping_phone: yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Please enter a valid Cell Phone Number'),
  email: yup.string().email('Please enter a valid email address').required("Required"),
  current_password: yup.string().label('Current Password').min(8, `Min. 8 characters.`),
  new_password: yup.string().label('New Password').min(8, `Min. 8 characters.`).matches(/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])/, "Password must contain at least one uppercase letter, one number, and one special character."),
});
